import type Consumer from "../models/Consumer";
import type { PdfFuseSort } from "./PdfExportConfig";

/** Compares full tags naturally, keeping unassigned channels or terminals at the end. */
function compareTags(left: string, right: string): number {
  if (!left || !right) return Number(!left) - Number(!right);
  return left.localeCompare(right, "de", { numeric: true });
}

/** Sorts a copy of circuit consumers; direct supplies lead actor sorting and use terminal order. */
export function sortFuseConsumers(consumers: Consumer[], sort: PdfFuseSort): Consumer[] {
  const rows = consumers.map((consumer) => {
    const channel = consumer.getConnectedChannel();
    const direct =
      !channel ||
      consumer.channelType === "suply230V" ||
      consumer.channelType === "suply400V" ||
      channel.channelType === "suply230V" ||
      channel.channelType === "suply400V";
    return {
      consumer,
      tag: consumer.fullTag,
      channel: channel?.fullTag ?? "",
      terminal: consumer.terminal?.fullTag ?? "",
      direct,
    };
  });
  rows.sort((left, right) => {
    if (sort === "actorChannel") {
      const supplyOrder = Number(right.direct) - Number(left.direct);
      if (supplyOrder) return supplyOrder;
      if (!left.direct) {
        const channelOrder = compareTags(left.channel, right.channel);
        if (channelOrder) return channelOrder;
      }
    }
    if (sort === "terminal" || sort === "actorChannel") {
      const terminalOrder = compareTags(left.terminal, right.terminal);
      if (terminalOrder) return terminalOrder;
    }
    return compareTags(left.tag, right.tag);
  });
  return rows.map((row) => row.consumer);
}
